import React from 'react';
import { ConfigProvider, App as AntApp } from 'antd';
import { StyleSheetManager } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';
import { MarkerProvider } from '../context/MarkerProvider';
import { AudioCallProvider } from '../context/AudioCallProvider';
import { StateProvider } from '../context/StateProvider';
import { MenuProvider } from '../context/MenuProvider';
import { antdTheme } from '../theme/antdTheme';

function shouldForwardProp(propName, target) {
  if (typeof target === 'string') {
    return isPropValid(propName);
  }
  return true;
}

export const AppProviders = ({ children }) => {
  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      <ConfigProvider theme={antdTheme}>
        <AntApp component={false}>
          <MarkerProvider>
            <AudioCallProvider>
              <StateProvider>
                <MenuProvider>
                  {children}
                </MenuProvider>
              </StateProvider>
            </AudioCallProvider>
          </MarkerProvider>
        </AntApp>
      </ConfigProvider>
    </StyleSheetManager>
  );
};

export default AppProviders;

